import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "edit" }
const _hoisted_2 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.show,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.show) = $event)),
      onClose: _ctx.close,
      title: _ctx.isEdit ? '编辑招聘' : '新增招聘',
      center: "",
      width: "50%",
      "before-close": _ctx.handleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_button, { onClick: _ctx.close }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.submitForm
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode("提交", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", null, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              ref: "ruleFormRef",
              model: _ctx.ruleForm,
              rules: _ctx.rules,
              "label-width": "120px",
              class: "demo-ruleForm"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "岗位名称",
                  prop: "title"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.title,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.title) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "岗位类型",
                  prop: "postTypeId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.ruleForm.postTypeId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.postTypeId) = $event)),
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posType, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.title,
                            value: item.id,
                            key: index
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "是否急招",
                  prop: "urgencyStatus"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.ruleForm.urgencyStatus,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.urgencyStatus) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "描述",
                  prop: "description"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.description,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.description) = $event)),
                      type: "textarea"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "跳转链接",
                  prop: "linkUrl"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.linkUrl,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ruleForm.linkUrl) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "薪资",
                  prop: "wages"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.wages,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ruleForm.wages) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "排序",
                  prop: "sortNum"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _ctx.ruleForm.sortNum,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.sortNum) = $event)),
                      min: 0,
                      max: 30
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose", "title", "before-close"])
  ]))
}